module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-17-min.b40b99ca.jpg";